import revertTitle from "./revertTitle";
import { titleCheckIntervalMilliseconds, isDebug } from "../../../configuration";

const listenForTitleChanges = (addNotification, updateResourceFileSize) => {

  let oldTitle = document.title;

  setInterval(async () => {
    let str = document.title;
    if (str !== oldTitle) {
      oldTitle = str;

      if (isDebug === true) {
        let notification = {
          id: Math.random(),
          title: "DEBUG message: WebBrowser title change detected",
          body: "Title changed to " + str,
          isAlert: false
        };

        addNotification(notification);
      }

      let titleParts = str.split('|');

      if (titleParts[0] === 'open' && titleParts[2] !== "") {
        addNotification({
          id: Math.random(),
          title: "Downloading CityCAD Model",
          body: '', //titleParts[2],
          isAlert: true
        });
        revertTitle();
      }

      if (titleParts[0] === 'update') {
        addNotification({
          id: Math.random(),
          title: "Saving CityCAD Model",
          body: titleParts[2],
          isAlert: true
        });
        revertTitle();
      }

      if (titleParts[0] === 'citycad') {

        if (titleParts[3] === 'open' && titleParts[5] === '0') {
          addNotification({
            id: Math.random(),
            title: "CityCAD model loaded",
            body: "",
            isAlert: true
          })
        }

        if (titleParts[3] === 'update' && titleParts[5] === '0') {
          const resourceID = Number.parseInt(titleParts[4]);
          await updateResourceFileSize(resourceID);
        }

        if (titleParts[2] === 'location-updated') {
          addNotification({
            id: Math.random(),
            title: "Model location updated",
            body: `The zero point of your CityCAD model is now located at latitude ${titleParts[3]}, longitude ${titleParts[4]}.`,
            isAlert: false
          })
        }

        revertTitle();
      }

      if (titleParts[5] === '2') {
        addNotification({
          id: Math.random(),
          title: "Operation cancelled",
          body: "",
          isWarning: true,
          isAlert: true
        });
        revertTitle();
      }


      // if (str.indexOf("|") !== -1) {
      //   const response = str.split("|");
      //   if (response[0] !== 'citycad')
      //     addMessage("Title changed to code " + str);
      //   if (response[1] === 'response' && response[2] === 'location-updated')
      //     addMessage("Location successfully updated to " + response[3] + "," + response[4]);
      // }
    }
  }, titleCheckIntervalMilliseconds)
};

export default listenForTitleChanges;
